import React from "react";
import { FormattedMessage } from "react-intl";
import DialogModalHeader from "../../../../components/dialogModal/dialogModalHeader";
import {
  TextField,
  Divider,
  InputAdornment,
  CircularProgress,
} from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import DisplayAppInfo from "./displayAppInfo";
import RevokeConsent from "./revokeConsent";
import { useConnectedAppProps } from "../connectedApps";
import ErrorMessage from "../connectedAppsError";

export const DisplayApps = () => {
  const { filteredApps, handleViewAndEdit, appStatus, currentApp } = useConnectedAppProps();

  return (
    <div className="account-list">
      {filteredApps &&
        filteredApps.map((app, i) => (
          <div key={i}>
            <div className="app-disp">
              <div className="app-name">{app?.application_logo && <img src={app?.application_logo} width={24} height={24} className="app-logo" alt="application_logo"/>}{app.application_name}</div>
            <div>
              {currentApp === app.application_id &&
                appStatus === "pending" ? (
                  <CircularProgress size="1.5rem" />
                ) : (
                  <span
                    className={
                      appStatus === "pending"
                        ? "action-link-disabled"
                        : "action-link"
                    }
                    role="button"
                    tabIndex={0}
                    onClick={(e) => handleViewAndEdit(e, app.application_id)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        handleViewAndEdit(e, app.application_id);
                      }
                    }}
                  >
                    <FormattedMessage defaultMessage="View and edit" />
                  </span>
                )}
              </div>
            </div>
            <Divider />
          </div>
        ))}
    </div>
  );
};

const ListConnectedApps = () => {
  const { appStatus, inputValue, handleInputChange, handleClose, error, apps } = useConnectedAppProps();
  return (
    <>
      {appStatus === "info" ? (
        <DisplayAppInfo />
      ) : appStatus === "revoke" || appStatus === "pending_revoke" ? (
        <RevokeConsent />
      ) : (
        <div className="account-modal-body">
          <DialogModalHeader
            handleClose={handleClose}
            title={<FormattedMessage defaultMessage="Third-party applications ({apps})" values={{ apps: apps.length }}/>}
          />
         
          {error && <div className="line-break"><ErrorMessage  error={error} /></div>}
      
          <div className="line-break">
          <FormattedMessage defaultMessage="You shared data with these applications. View the application details to review and manage the data you share."/>
          </div>

          {apps.length > 5 &&
          <TextField
            placeholder="Filter by name"
            className="search-text-field"
            value={inputValue}
            onChange={(e) => handleInputChange(e)}
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FilterListIcon />
                </InputAdornment>
              ),
            }}
          />}
          <DisplayApps />
        </div>
      )}
    </>
  );
};

export default ListConnectedApps;
